import { render, staticRenderFns } from "./TopServicesByRevenues.vue?vue&type=template&id=42b56926&"
import script from "./TopServicesByRevenues.vue?vue&type=script&lang=js&"
export * from "./TopServicesByRevenues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports